import "leaflet";
import "lity";
import { MarkerClusterGroup } from "leaflet.markercluster/src";

(function ($) {
  //=================================
  //
  //  ###    ###    ###    #####
  //  ## #  # ##   ## ##   ##  ##
  //  ##  ##  ##  ##   ##  #####
  //  ##      ##  #######  ##
  //  ##      ##  ##   ##  ##
  //
  //=================================

  /**
   * Variables.
   */
  const mapElement = document.querySelector("#references-map");
  let map = null;
  const markersCluster = new MarkerClusterGroup({
    iconCreateFunction: (cluster) => {
      return L.divIcon({
        html: cluster.getChildCount(),
        className: "map-cluster",
        iconSize: null,
      });
    },
  });
  const iconRatio = 0.4;
  const markerIcon = L.icon({
    iconUrl: window.LPREF.assets.map_marker,
    iconSize: [75 * iconRatio, 98 * iconRatio],
    iconAnchor: [38 * iconRatio, 98 * iconRatio],
    popupAnchor: [0, 98 * iconRatio * -1],
  });

  /**
   * Initialize the map with all the reference markers.
   */
  const initMap = () => {
    map = L.map("references-map").setView([46.90296, 1.90925], 6);

    L.tileLayer("http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
      attribution: "Données &copy; OpenStreetMap",
      maxZoom: 8,
    }).addTo(map);

    window.LPREF.data.references.map((reference, referenceIndex) => {
      if (!reference.latitude || !reference.longitude) {
        return;
      }

      const marker = L.marker([reference.latitude, reference.longitude], {
        icon: markerIcon,
      })
        // .addTo(map)
        // .bindPopup(getMarkerTooltipContent(reference));

      markersCluster.addLayer(marker);
    });

    map.addLayer(markersCluster);
  };

  /**
   * Get a map tooltip marker content.
   */
  const getMarkerTooltipContent = (reference) => {
    return `<div class="reference-tooltip-content ${
      reference.video ? "with-video" : "without-video"
    }">
			<h4>${reference.name}</h4>
      ${reference.offer ? `<h5>${reference.offer}</h5>` : ""}
			${
        reference.video
          ? `<a href="#" data-video-id="${reference.video}">Voir le témoignage vidéo</a>`
          : ""
      }
		</div>`;
  };

  //=====================================================
  //
  //  #####    #####   #####   ##   ##  #####    ####
  //  ##  ##  ##   ##  ##  ##  ##   ##  ##  ##  ##
  //  #####   ##   ##  #####   ##   ##  #####    ###
  //  ##      ##   ##  ##      ##   ##  ##         ##
  //  ##       #####   ##       #####   ##      ####
  //
  //=====================================================

  /**
   * Variables.
   */
  const videosListing = document.querySelector("#videos-listing");

  /**
   * Initialize the popup logics.
   */
  const initPopup = () => {
    $(mapElement).on(
      "click",
      "div.reference-tooltip-content a[data-video-id]",
      function (e) {
        e.preventDefault();
        const videoId = $(this).data("video-id");
        const $videoItem = $(videosListing).find(`a[data-id="${videoId}"]`);

        if ($videoItem) {
          $videoItem.trigger("click");
        }
      }
    );
  };

  //================================================
  //
  //  ##   ##  ##  ####    #####   #####    ####
  //  ##   ##  ##  ##  ##  ##     ##   ##  ##
  //  ##   ##  ##  ##  ##  #####  ##   ##   ###
  //   ## ##   ##  ##  ##  ##     ##   ##     ##
  //    ###    ##  ####    #####   #####   ####
  //
  //================================================

  /**
   * Variables.
   */
  const videos = document.querySelectorAll("#videos-listing .video-item");
  const maxVideos = 15;
  const filterRegion = document.querySelector("#videos-filter .filter-region");
  const filterOffer = document.querySelector("#videos-filter .filter-offer");

  /**
   * Initialize all logic related to the videos section (filters, see more button).
   */
  const initVideos = () => {
    // Only display 15 videos initially.
    if ($(videos).length > maxVideos) {
      $(videos)
        .filter(`:gt(${maxVideos - 1})`)
        .hide();

      // Add "Voir plus" button.
      $(
        `<div id="load-more-videos"><span class="button">Voir plus</span></div>`
      ).insertAfter($(videosListing));
    }

    // Load more button.
    $("main#genesis-content").on(
      "click",
      "#load-more-videos .button",
      function () {
        $(videos).not(":visible").slideDown();
        $(this).slideUp();
      }
    );

    // Filter by region logic.
    $(filterRegion).change(filterVideos);

    // Filter by offer logic.
    $(filterOffer).change(filterVideos);

    $(
      '<p id="filtered-no-results">Aucun témoignage vidéo ne correspond à vos critères pour le moment.</p>'
    )
      .insertBefore("#load-more-videos .button")
      .hide();
  };

  /**
   * Filter videos by a region or offer ID.
   */
  const filterVideos = () => {
    const regionId = parseInt(
      $(filterRegion).find("option:selected").eq(0).val()
    );
    const offerId = parseInt(
      $(filterOffer).find("option:selected").eq(0).val()
    );

    $("#filtered-no-results").hide();
    $(videos).show();

    if (regionId > 0 || offerId > 0) {
      let $filteredVideos;

      if (regionId > 0 && offerId < 0) {
        $filteredVideos = $(videos).not(`[data-region="${regionId}"]`);
      } else if (offerId > 0 && regionId < 0) {
        $filteredVideos = $(videos).not(`[data-offer="${offerId}"]`);
      } else if (regionId > 0 && offerId > 0) {
        $filteredVideos = $(videos).not(
          `[data-offer="${offerId}"][data-region="${regionId}"]`
        );
      }

      $filteredVideos.hide();

      $("#load-more-videos .button").hide();

      // If no results…
      if ($(videos).filter(":visible").length === 0) {
        $("#filtered-no-results").show();
      }
    } else {
      if ($(videos).length > maxVideos) {
        $(videos)
          .filter(`:gt(${maxVideos - 1})`)
          .hide();
        $("#load-more-videos .button").show();
      }
    }
  };

  //===============================
  //
  //  ##  ##     ##  ##  ######
  //  ##  ####   ##  ##    ##
  //  ##  ##  ## ##  ##    ##
  //  ##  ##    ###  ##    ##
  //  ##  ##     ##  ##    ##
  //
  //===============================

  /**
   * Initialize everything.
   */
  if (mapElement) {
    initMap();
  }

  if (videosListing) {
    initPopup();
    initVideos();
  }
})(jQuery);
